// TODO: dead after surveys.dataxing.com prescreener move (2026-05-08).
// Vendor partners are now redirected from admin's resolvePartnerEntry to
// surveys.dataxing.com/#/PartnerPreScreenQues/:surveyId/:userId — same
// component as the panelist flow, with backend evaluator branching by
// user_id. This country component is no longer reachable.
// Keep the file until next cleanup pass.

import { makeStyles, Paper, Typography, Container } from "@material-ui/core";
import { Assets } from "enums";
import { useEffect, useState } from "react";
import { AuthAPI } from "API";
import { useLocation } from "react-router";
import Select from 'react-select';
import { branding } from '../../config/portalBranding';

// Define types for API response
interface Question {
    survey_id: string;
    id: number;
    created_at: string;
    updated_at: string;
    deleted_at?: string;
    status: string;
    question: string;
    answer: string;
}

function PartnerPreScreenQuesPage() {
    const [partnerPreScreenApiData, setPartnerPreScreenApiData] = useState<Question[]>([]);
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [currentQues, setCurrentQues] = useState<Question | null>(null);
    const [formData, setFormData] = useState<{ question: string; answer: [] }[]>([{ question: "", answer: [] }]);
    const [submitQueBtnTF, setSubmitQueBtnTF] = useState(false);
    const location = useLocation();

    const useStyles = makeStyles((theme) => ({
        root: { flexGrow: 1, },
        appBar: { marginBottom: theme.spacing(3), },
        content: { padding: theme.spacing(3), textAlign: 'left', },
        paper: { padding: theme.spacing(2), display: 'flex', overflow: 'auto', flexDirection: 'column', alignItems: 'center', },
        logo: { width: '100%', maxWidth: '400px', },
        grow: { flexGrow: 1, },
        btn: {
            padding: "10px 20px", color: "black", backgroundColor: "linear-gradient(#e7e7e7, #f3f3f3)", borderRadius: "10px", border: "1px solid #8f8f8f", margin: "1rem",
            '&:hover': { backgroundColor: "#008083 !important", color: "#ffffff", transform: "scale(1.05)", },
        },
        progress: {
            background: "rgba(0,0,0,.2)", borderRadius: "5px", width: "30%", height: "1rem",
            [theme.breakpoints.down('sm')]: { width: "80%", },
            [theme.breakpoints.up('sm')]: { width: "30%", },
        },
        footer: { bottom: 10, right: 10, display: 'flex', position: "fixed", padding: "10px" },
    }));

    const partnerPreScreenfetchList = async () => {
        const data = { survey_id: location.pathname.split("/").at(-2) };
        try {
            const responseQuesData: Question[] = await AuthAPI.getSurveyQuestions(data);
            const responsePartnerData = responseQuesData.toSorted((a, b) => { return a.questionDisplayOrder - b.questionDisplayOrder });
            setPartnerPreScreenApiData(responsePartnerData);
            setCurrentQues(responsePartnerData[0] || null);
        } catch (err) {
            console.error("Failed to fetch survey questions:", err);
        }
    };

    const nextButton = () => {
        if (formData[currentIndex].answer.length < 1) { alert("choose answer"); return; }
        if (currentIndex < partnerPreScreenApiData.length - 1) {
            setFormData((prevFormData) => {
                if (currentIndex == prevFormData.length - 1 && prevFormData.length < partnerPreScreenApiData.length) {
                    return [...prevFormData, { "question": "", "answer": [] }];
                } else { return [...prevFormData]; }
            });
            setCurrentIndex(currentIndex + 1);
            setCurrentQues(partnerPreScreenApiData[currentIndex + 1]);
        }
    };

    const previousButton = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
            setCurrentQues(partnerPreScreenApiData[currentIndex - 1]);
        }
    };

    const handleSelectAnswer = (evt, answer, type) => {
        let newAnsArr = [];
        setFormData((prevFormData) => {
            const updatedFormData = [...prevFormData];
            const previousAnswers = updatedFormData[currentIndex] ? updatedFormData[currentIndex].answer : [];
            if (type == "checkbox") {
                newAnsArr = evt.target.checked ? [...previousAnswers, answer] : [...previousAnswers].filter(e => e != answer);
            } else {
                newAnsArr = [...previousAnswers, answer].filter(e => e == answer && e != "");
            }
            updatedFormData[currentIndex] = { "question": currentQues?.id, "answer": newAnsArr };
            return updatedFormData;
        });
    }

    const handleMultiSelectAnswers = (selectedMultipleAnswers) => {
        setFormData((prevFormData) => {
            const updatedFormData = [...prevFormData];
            let newSelectedAnsArr = selectedMultipleAnswers.map(option => option.value);
            updatedFormData[currentIndex] = { "question": currentQues?.id, "answer": newSelectedAnsArr };
            return updatedFormData;
        });
    }

    const handleDropDownSelectAnswers = (selectedOptVal) => {
        setFormData((prevFormData) => {
            let newOptArr = selectedOptVal.value;
            const updatedFormData = [...prevFormData];
            updatedFormData[currentIndex] = { "question": currentQues?.id, "answer": [newOptArr] };
            return updatedFormData;
        });
    }

    const handleQueSubmit = async () => {
        if (formData[currentIndex].answer.length < 1 && partnerPreScreenApiData.length > 0) { alert("choose answer"); return; }
        const data = {
            survey_id: location.pathname.split('/').at(-2),
            user_id: location.pathname.split('/').at(-1),
            details: partnerPreScreenApiData.length > 0 ? formData : []
        };

        try {
            setSubmitQueBtnTF(true);
            const respoMatch = await AuthAPI.matchAnswersPartner(data);
            window.history.replaceState(null, '', '');
            window.location.href = respoMatch;
        } catch (err) {
            setSubmitQueBtnTF(false);
            alert(err);
            console.error("Submission error:", err);
        }
    };



    const classes = useStyles();

    useEffect(() => { partnerPreScreenfetchList(); }, []);

    return (
        <div className={classes.root}>
            <Container maxWidth="lg" className={classes.content}>
                <Paper className={classes.paper}>
                    <img alt="Logo" src={branding.logo || Assets.Logo2} className={classes.logo} />
                </Paper>
                {partnerPreScreenApiData.length > 0 ? <div className="mt-1">
                    <div
                        className=" w-100"
                        style={{ textAlign: "center", marginTop: "2rem" }}
                    >
                        <div>{`${currentIndex + 1}/${partnerPreScreenApiData.length}`}</div>
                        <Typography
                            variant="h4"
                            className="mt-5"
                        >
                            {currentQues ? "" : "Loading question..."}
                        </Typography>
                    </div>
                    <div className="" style={{ display: "grid", placeItems: "center" }}>
                        <div>
                            {currentQues?.question && (
                                <div className="">
                                    <div className="">
                                        <h5>{currentQues ? currentQues.question : ""}</h5>
                                        {
                                            currentQues.questionType === "Radio" &&
                                            currentQues?.answer?.map((elem, index) => (
                                                <div className="custom-control custom-radio" key={"radio" + index}>
                                                    <input
                                                        type="radio"
                                                        id={`prescreen-${index}`}
                                                        name={`prescreen-${index}`}
                                                        checked={formData[currentIndex]?.answer.includes(elem) || false}
                                                        className="custom-control-input"
                                                        onChange={(evt) => handleSelectAnswer(evt, elem, "radio")}
                                                    />
                                                    <label className="custom-control-label" htmlFor={`prescreen-${index}`}><span className='text-lg'>{elem}</span></label>
                                                </div>
                                            ))
                                        }
                                        {(currentQues.questionType === "Checkbox" || currentQues.questionType === "checkbox") &&
                                            currentQues?.answer?.map((elem, index) => (
                                                <div className="col ml-2" key={"checkBoxx" + index}>
                                                    <input
                                                        type="checkbox"
                                                        id={`prescreen-${index}`}
                                                        name={`prescreen-${index}`}
                                                        checked={formData[currentIndex]?.answer.includes(elem) || false}
                                                        className="custom-control-input"
                                                        onChange={(evt) => handleSelectAnswer(evt, elem, "checkbox")}
                                                    />
                                                    <label className="custom-control-label" htmlFor={`prescreen-${index}`}><span className='text-lg'>{elem}</span></label>
                                                </div>
                                            ))
                                        }
                                        {(currentQues?.questionType == "Range") &&
                                            <div>
                                                <select
                                                    name="rangeSelect"
                                                    id="rangeSelect"
                                                    className="form-control"
                                                    value={formData[currentIndex]?.answer.length > 0 ? formData[currentIndex]?.answer[0] : ""}
                                                    onChange={(evt) => handleSelectAnswer(evt, evt.target.value, "Range")}
                                                >
                                                    <option value="">Select option</option>
                                                    {(() => {
                                                        let result = [];
                                                        currentQues?.answer?.forEach(range => {
                                                            const from = parseInt(range.answer.fromValue, 10);
                                                            const to = parseInt(range.answer.toValue, 10);
                                                            for (let i = from; i <= to; i++) { result.push(i); };
                                                        });
                                                        let finalResult = Array.from(new Set(result)).sort((a, b) => { return (a - b) });
                                                        return finalResult.map((value) => (
                                                            <option value={value} key={value + "123"}> {value} </option>
                                                        ));
                                                    })()}
                                                </select>
                                            </div>
                                        }
                                        {(currentQues?.questionType == "MultiSelectDropdown") &&
                                            <div>
                                                <Select
                                                    name='MultiSelectDropdown'
                                                    id='MultiSelectDropdown'
                                                    onChange={(evt) => handleMultiSelectAnswers(evt)}
                                                    value={formData[currentIndex]?.answer.length > 0 ? formData[currentIndex]?.answer?.map((ele) => { return { label: ele, value: ele } }) : ""}
                                                    isMulti
                                                    options={currentQues?.answer?.map((ele) => { return { label: ele, value: ele } })}
                                                />
                                            </div>
                                        }
                                        {(currentQues?.questionType == "Dropdown") &&
                                            <div>
                                                <Select
                                                    name='Dropdown'
                                                    id='Dropdown'
                                                    onChange={(evt) => handleDropDownSelectAnswers(evt)}
                                                    value={formData[currentIndex]?.answer.length > 0 ? formData[currentIndex]?.answer?.map((ele) => { return { label: ele, value: ele } }) : ""}
                                                    options={currentQues?.answer?.map((ele) => { return { label: ele, value: ele } })}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="mt-5" style={{ display: "grid", placeItems: "center", width: "100%" }}>
                        <div className={classes.progress}>
                            <div style={{ background: "#008083", borderRadius: "5px", width: `${(currentIndex + 1) / partnerPreScreenApiData.length * 100 + "%"}`, height: "1rem" }}></div>
                            <div style={{ textAlign: "end" }}>{Math.ceil((currentIndex + 1) / (partnerPreScreenApiData.length) * 100) + "%"}</div>
                        </div>
                    </div>
                </div> :
                    <div className="mt-5 text-center">
                        <h1>Click "Proceed" to continue survey.</h1>
                    </div>
                }
                <div>
                    <div className={classes.footer}>
                        <button
                            type="button"
                            onClick={previousButton}
                            className="btn btn-primary mr-3"
                            disabled={currentIndex === 0}
                        >
                            Previous
                        </button>
                        <button
                            type="button"
                            onClick={currentIndex < partnerPreScreenApiData.length - 1 ? nextButton : handleQueSubmit}
                            className="btn btn-primary mr-3"
                            disabled={submitQueBtnTF}
                        >
                            {currentIndex < partnerPreScreenApiData.length - 1 ? "Next" : "Proceed"}
                        </button>
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default PartnerPreScreenQuesPage;